<template>
  <div class="ol-actions-panel" role="tabpanel">
    <textarea
      v-model="comment"
      class="ol-actions-note__textarea"
      :placeholder="$t('lang.opportunities.add_note_placeholder')"
      rows="4"
    />
    <div class="ol-actions-panel__footer ol-actions-panel__footer--end">
      <button
        id="btn-send"
        type="button"
        class="ol-actions-btn ol-actions-btn--primary"
        :disabled="!canSave"
        @click="createComment"
      >
        {{ $t("lang.opportunities.publish_note") }}
      </button>
    </div>
  </div>
</template>

<script>
import { linksService } from "@/_services";

export default {
  data() {
    return {
      comment: "",
    };
  },

  props: {
    linkId: String,
  },

  watch: {
    comment() {
      this.comment = this.$sanitize(this.comment);
    },
  },

  computed: {
    user() {
      return this.$store.state.authentication.user;
    },

    canSave() {
      return this.comment != "";
    },
  },

  methods: {
    createComment() {
      const button = document.getElementById("btn-send");
      if (button) {
        button.disabled = true;
      }
      linksService.createComment(this.linkId, this.comment).then(() => {
        var newDate = new Date();
        var creationDate =
          [
            newDate.getFullYear(),
            ("0" + (newDate.getMonth() + 1)).slice(-2),
            ("0" + newDate.getDate()).slice(-2),
          ].join("-") +
          " " +
          [
            ("0" + newDate.getHours()).slice(-2),
            ("0" + newDate.getMinutes()).slice(-2),
            ("0" + newDate.getSeconds()).slice(-2),
          ].join(":");

        var newComment = {
          id: "newComment",
          link_id: this.linkId,
          user_id: this.user.id,
          name: this.user.name + " " + this.user.lastname,
          type: "comment",
          comment: this.comment,
          creation_date: creationDate,
          user_name: this.user.name,
          user_lastname: this.user.lastname,
        };

        this.comment = "";
        if (button) {
          button.disabled = false;
        }
        this.$emit("createComment", newComment);
      });
    },
  },
};
</script>

<style scoped>
.ol-actions-panel {
  padding: 1rem 1.25rem;
}

.ol-actions-note__textarea {
  width: 100%;
  min-height: 90px;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  padding: 12px 14px;
  font-size: 13px;
  font-family: inherit;
  color: #111827;
  resize: vertical;
  background: #fafafb;
  line-height: 1.5;
  outline: none;
  box-sizing: border-box;
}

.ol-actions-note__textarea:focus {
  border-color: #4b4be1;
}

.ol-actions-panel__footer {
  display: flex;
  align-items: center;
  margin-top: 10px;
}

.ol-actions-panel__footer--end {
  justify-content: flex-end;
}

.ol-actions-btn {
  border: none;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  padding: 8px 16px;
  line-height: 1.2;
}

.ol-actions-btn--primary {
  background: #4b4be1;
  color: white;
}

.ol-actions-btn--primary:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
</style>
